<script setup lang="ts">
/* Detail routes get the viewport to themselves: no studio sidebar, because a
   detail view supplies its own focused left panel via `PolicyStudioWorkspace`,
   which is a `UDashboardGroup` and positions itself over the full viewport. */
</script>

<template>
  <slot />
</template>
